import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class SurveyTransferQuestionRulesSearchParams extends SearchParamsBase {
  initialize() {
    // The parent mapping scope is injected by the page (from the ?id= url param);
    // it is not a visible search field.
    this.SurveyTransferMappingId = '';
    this.TargetQuestionText = '';
    this.SourceQuestionText = '';
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'SurveyTransferQuestionRulesSearchParams';

  static fieldsInSearchBox = [
    { fieldName: 'TargetQuestionText', label: 'Target Question Text', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'SourceQuestionText', label: 'Source Question Text', className: 'col-4', type: InputTypesEnum.Text },
  ];

}
